import React from "react";
import "./Linktree.css";
import IMGLOGO from "../../../assets/images/listra-fina.png";

const Linktree = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <div className="container d-column justify-content-center p-3">
      <div className="d-flex justify-content-center mb-4">
        <img className="linktree-image" src={IMGLOGO} alt="" />
      </div>
      <div className="d-flex justify-content-center mb-4">
        <span className="text-white instagram-nome">@jotav.drone</span>
      </div>

      <div className="container d-flex justify-content-center">
        <div className={`row ${!matchResult ? "w-50" : "w-100"}`}>
          <a
            className="btn btn-lg btn-block botao-entrar "
            href="https://jotavdrone-1dce0.web.app/"
          >
            Site
          </a>
          <a
            className="btn btn-lg btn-block botao-entrar "
            href="https://api.whatsapp.com/message/UGNOJ2HSFVUSE1?autoload=1&app_absent=0"
          >
            Whatsapp
          </a>
        </div>
      </div>
    </div>
  );
};

export default Linktree;
